import { useHistory } from 'react-router-dom';
import { IdpState, InvitationParams } from '@cp-es/common';

export const useInvitationParams = (): InvitationParams | undefined => {
    const history = useHistory();
    const lastLocation = history?.location?.state as IdpState;

    return lastLocation?.invitation;
};
